import { PasswordProtectionCredentials } from 'pages/PasswordProtection/passwordProtection.types';
import { LOCAL_STORAGE_PASSWORD_PROTECTION_CREDENTIALS } from 'pages/PasswordProtection/passwordProtection.constants';

export const saveCredentialsToStorage = (credentials: PasswordProtectionCredentials) => {
  localStorage.setItem(LOCAL_STORAGE_PASSWORD_PROTECTION_CREDENTIALS, JSON.stringify(credentials));
};

export const getCredentialsFromStorage = () => {
  const credentialsInJson = localStorage.getItem(LOCAL_STORAGE_PASSWORD_PROTECTION_CREDENTIALS);

  if (credentialsInJson) {
    return JSON.parse(credentialsInJson) as PasswordProtectionCredentials;
  }

  return null;
};

export const removeCredentialsFromStorage = () => {
  localStorage.removeItem(LOCAL_STORAGE_PASSWORD_PROTECTION_CREDENTIALS);
};
